import { Tag } from 'common';

import { NodeAnalyticEventDecorator } from './AnalyticEventDecorator';
import { DeprecatedModelDecorator } from './DeprecatedModel';
import { NodeSubFlowDecorator } from './SubFlowDecorator';
import { useReactFlowViewContext } from '../../../../context/context';
import { type ReactFlowBlockNodeProps } from '../types';
import { RetiredBlockDecorator } from './RetiredBlock';

interface NodeCardDecoratorsProps {
  data: ReactFlowBlockNodeProps['data'];
  nodeId: string;
}

export function NodeCardDecorators(props: NodeCardDecoratorsProps) {
  const {
    data,
    data: { mockDataEnabled },
    nodeId,
  } = props;
  const { isMockEnabledVisible } = useReactFlowViewContext();
  return (
    <>
      <RetiredBlockDecorator data={data} />
      <DeprecatedModelDecorator data={data} />
      {isMockEnabledVisible && mockDataEnabled && (
        <Tag color="warning" sx={{ alignSelf: 'start' }}>
          Mocked output
        </Tag>
      )}
      <NodeAnalyticEventDecorator events={data.events} nodeId={nodeId} />
      <NodeSubFlowDecorator data={data} />
    </>
  );
}
